<div class="unilever-spc-app fw fh">
    <!-- Keep router-outlet ALWAYS in DOM for Angular routing to work properly -->
    <router-outlet></router-outlet>

    <!-- Regular loader for app interactions -->
    <app-overlay-loader></app-overlay-loader>
</div>